import * as propertyTypes from "../../property_types.js"
import { DataIsTemplateStringProperty, RightDrawerContainer, DataMenu, DataGridOptions } from "./common_app_metadata.js";

export class AppProcedure extends propertyTypes.Serializable {

    private additionalMetadata = new propertyTypes.ObjectPropertyExt("additional", "Additional")
        .addStateImplementation("default", Additional);
    public additional: Additional;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.additionalMetadata.RenderInline = true;
        this.metadataAll = [this.additionalMetadata];
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }
}

class Additional extends propertyTypes.Serializable {

    private objectsMetadata = new propertyTypes.ObjectListPropertyExt("objects", "Additional objects", "name")
        .addStateImplementation("browserTitle", DataIsTemplateStringProperty)
        .addStateImplementation("pageTitle", DataIsTemplateStringProperty)
        .addStateImplementation("historyGridOptions", DataGridOptions)
        .addStateImplementation("articleGridOptions", DataGridOptions)
        .addStateImplementation("ticketLevelGridOptions", DataGridOptions)
        .addStateImplementation("editMachineTicketsGridOptions", DataGridOptions)
        .addStateImplementation("menuDataSource", DataMenu)
        .addStateImplementation("translations", DataTranslations)
        .addStateImplementation("ticketStructureTemplate", DataIsTemplateStringProperty)
        .addStateImplementation("rightDrawerContainer", RightDrawerContainer);

    public objects: string;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.objectsMetadata.IsReadOnly = true;
        this.additionalMetadata = [this.objectsMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class DataTranslations extends propertyTypes.Serializable {
    private nameMetadata = new propertyTypes.TextProperty("name", "Name");
    public name: string;

    private dataMetadata = new propertyTypes.ObjectPropertyExt("data", "Data")
        .addStateImplementation("default", Translations);
    public data: Translations;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.nameMetadata.IsReadOnly = true;
        this.additionalMetadata = [this.nameMetadata, this.dataMetadata];
        //this.dataMetadata.RenderInline = true;
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class Translations extends propertyTypes.Serializable {
    private Standard_Msg_LoeschenMetadata = new propertyTypes.TranslatableTextProperty("Standard.Msg.Loeschen", "Standard.Msg.Loeschen");
    private Vorgang_VorgangSchliessenFrageMetadata = new propertyTypes.TranslatableTextProperty("Vorgang.VorgangSchliessenFrage", "Vorgang.VorgangSchliessenFrage");
    private Vorgang_VorgangWiedereroeffnenFrageMetadata = new propertyTypes.TranslatableTextProperty("Vorgang.VorgangWiedereroeffnenFrage", "Vorgang.VorgangWiedereroeffnenFrage");
    private WebSMS_Ticket_Assignment_NewAssignmentMetadata = new propertyTypes.TranslatableTextProperty("WebSMS.Ticket.Assignment.NewAssignment", "WebSMS.Ticket.Assignment.NewAssignment");
    private Vorgang_VorgangWeiterleitenMetadata = new propertyTypes.TranslatableTextProperty("Vorgang.VorgangWeiterleiten", "Vorgang.VorgangWeiterleiten");

    private Standard_NeuMetadata = new propertyTypes.TranslatableTextProperty("Standard.Neu", "Standard.Neu");
    private Standard_EditierenMetadata = new propertyTypes.TranslatableTextProperty("Standard.Editieren", "Standard.Editieren");
    private Standard_LoeschenMetadata = new propertyTypes.TranslatableTextProperty("Standard.Loeschen", "Standard.Loeschen");
    private Vorgang_ArtikelZumVorgangMetadata = new propertyTypes.TranslatableTextProperty("Vorgang.ArtikelZumVorgang", "Vorgang.ArtikelZumVorgang");
    private MonitorBaum_NeuLadenMetadata = new propertyTypes.TranslatableTextProperty("MonitorBaum.NeuLaden", "MonitorBaum.NeuLaden");

    private WebSMS_Ticket_Allocations_TicketAllocationMetadata = new propertyTypes.TranslatableTextProperty("WebSMS.Ticket.Allocations.TicketAllocation", "WebSMS.Ticket.Allocations.TicketAllocation");
    private WebSMS_Ticket_CopyMaterialToProjectMetadata = new propertyTypes.TranslatableTextProperty("WebSMS.Ticket.CopyMaterialToProject", "WebSMS.Ticket.CopyMaterialToProject");
    private WebSMS_Ticket_SaveRequiredMetadata = new propertyTypes.TranslatableTextProperty("WebSMS.Ticket.SaveRequired", "WebSMS.Ticket.SaveRequired");
    private Field_Vorgang_stufeMetadata = new propertyTypes.TranslatableTextProperty("Field.Vorgang.stufe", "Field.Vorgang.stufe");
    private WebCRM_Email_SendMetadata = new propertyTypes.TranslatableTextProperty("WebCRM.Email.Send", "WebCRM.Email.Send");

    private allTranslationsMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allTranslationsMetadata = [this.Standard_Msg_LoeschenMetadata, this.Vorgang_VorgangSchliessenFrageMetadata, this.Vorgang_VorgangWiedereroeffnenFrageMetadata,
        this.WebSMS_Ticket_Assignment_NewAssignmentMetadata, this.Vorgang_VorgangWeiterleitenMetadata, this.Standard_NeuMetadata, this.Standard_EditierenMetadata,
        this.Standard_LoeschenMetadata, this.Vorgang_ArtikelZumVorgangMetadata, this.MonitorBaum_NeuLadenMetadata, this.WebSMS_Ticket_Allocations_TicketAllocationMetadata,
        this.WebSMS_Ticket_CopyMaterialToProjectMetadata, this.WebSMS_Ticket_SaveRequiredMetadata, this.Field_Vorgang_stufeMetadata, this.WebCRM_Email_SendMetadata
        ];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allTranslationsMetadata;
    }
}
